import React from 'react'
import * as UI from 'ui'
import { useValue } from '@morningtrain/react-resources'
import OnboardingChecklistProgress from 'support/displays/OnboardingChecklistProgress'
import { Translation } from '@morningtrain/react-translations'
import * as Displays from 'support/displays'
import moment from 'moment'

export default function EmployeeOnboardingInfo () {
  const employeeName = useValue('user.name')
  const avatarUrl = useValue('user.avatar_url')

  const latestChecklistAt = useValue('latest_checklist_at', null)

  const latestChecklistDate = moment(latestChecklistAt).format('DD.MM.YYYY')

  return (
    <UI.FlexGrid cols={3}>
      <UI.EmployeeInfo
        title={employeeName}
        text={(
          <div className='flex flex-col space-y-1'>
            <UI.Text block>
              <Displays.Text name='user.employment_name'/>
            </UI.Text>
            <UI.Text block>
              <Translation name='latest_checklist_date' data={{ date: latestChecklistDate }}/>
            </UI.Text>
          </div>
        )}
        avatar={<img src={avatarUrl}/>}
      />
      <div className='flex flex-col pl-12'>
        <UI.Text uppercase size='xs' color='gray'>
          <Translation name='onboarding.summary.completed_tasks'/>
        </UI.Text>
        <div className='space-x-2 flex items-center'>
          <UI.Text size='sm'>
            <Displays.Integer name='summary.completed_fields_count'/>
            <span> / </span>
            <Displays.Integer name='summary.fields_count'/>
          </UI.Text>
          <OnboardingChecklistProgress className='inline-block flex-grow' displayText={false}
                                       progressName='summary.completed_percentage'/>
        </div>
      </div>
      <div className='flex flex-col pl-12'>
        <UI.Text uppercase size='xs' color='gray'>
          <Translation name='onboarding.summary.approved_tasks'/>
        </UI.Text>
        <div className='space-x-2 flex items-center'>
          <UI.Text size='sm'>
            <Displays.Integer name='summary.filled_fields_count'/>
            <span> / </span>
            <Displays.Integer name='summary.fields_count'/>
          </UI.Text>
          <OnboardingChecklistProgress className='inline-block flex-grow' displayText={false}
                                       progressName='summary.finished_percentage'/>
        </div>
      </div>
    </UI.FlexGrid>
  )
}
